import React, { useReducer, useEffect } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { GoogleTagManager } from '@ta-interaktiv/react-gtm';
import { getTitle, getCategory, getSubCategory, isPremium, getPublishingDate, getAuthors } from '@ta-interaktiv/api-access';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var domain = parseHostname().publicationName;
var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'SET_VALUE':
            return {
                hasLoaded: __assign(__assign({}, state.hasLoaded), (_a = {}, _a[action.meta] = true, _a)),
                values: __assign(__assign({}, state.values), (_b = {}, _b[action.meta] = action.payload, _b))
            };
    }
    return state;
};
var setValue = function (value, key) { return ({
    type: 'SET_VALUE',
    payload: value,
    meta: key
}); };
var defaultValues = {
    article_title: '',
    article_type: 'interactive-standalone',
    pagetype: 'content',
    category: '',
    subcategory: '',
    premium: 0,
    publish_date: '',
    author_name: ''
};
var defaultLoadingValues = Object.keys(defaultValues).reduce(function (previousValue, currentValue) {
    previousValue[currentValue] = false;
    return previousValue;
}, {});
function Tracking(_a) {
    var gtmId = _a.gtmId, articleId = _a.articleId;
    var _b = useReducer(reducer, {
        hasLoaded: defaultLoadingValues,
        values: defaultValues
    }), state = _b[0], dispatch = _b[1];
    useEffect(function () {
        if (articleId) {
            try {
                getTitle(domain, articleId).then(function (title) {
                    return dispatch(setValue(title !== null && title !== void 0 ? title : '', 'article_title'));
                });
                dispatch(setValue('interactive-standalone', 'article_type'));
                dispatch(setValue('content', 'pagetype'));
                getCategory(domain, articleId).then(function (category) {
                    return dispatch(setValue(category !== null && category !== void 0 ? category : '', 'category'));
                });
                getSubCategory(domain, articleId).then(function (subcategory) {
                    return dispatch(setValue(subcategory !== null && subcategory !== void 0 ? subcategory : '', 'subcategory'));
                });
                isPremium(domain, articleId).then(function (isPremium) {
                    return dispatch(setValue(isPremium ? 1 : 0, 'premium'));
                });
                getPublishingDate(domain, articleId).then(function (date) {
                    return dispatch(setValue(date !== null && date !== void 0 ? date : '', 'publish_date'));
                });
                getAuthors(domain, articleId).then(function (authorList) {
                    return dispatch(setValue(authorList.join(', '), 'author_name'));
                });
            }
            catch (e) {
                console.debug('[Tracking] Could not set up tracking due to an Error.', e);
            }
        }
        else {
            dispatch(setValue(window.document.title, 'article_title'));
            dispatch(setValue('interactive-embeddable', 'article_type'));
            dispatch(setValue('embeddable', 'pagetype'));
            dispatch(setValue('', 'category'));
            dispatch(setValue('', 'subcategory'));
            dispatch(setValue(0, 'premium'));
            dispatch(setValue('', 'publish_date'));
            dispatch(setValue('', 'author_name'));
        }
    }, [articleId]);
    if (!gtmId) {
        return null;
    }
    if (Object.values(state.hasLoaded).every(function (val) { return val; })) {
        return (React.createElement(GoogleTagManager, __assign({ gtmId: gtmId, article_id: articleId, event: 'pageview' }, state.values)));
    }
    return null;
}

export { Tracking };
//# sourceMappingURL=index.m.js.map
